import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "YAMAHA  ", -1);
var _hoisted_2 = {
  class: "c-download-hang-safe-bottom",
  ref: "bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _directive_touch = _resolveDirective("touch");
  return !_ctx.isApp ? _withDirectives((_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "c-download-hang moblink-app main_bg_color",
    style: _normalizeStyle($options.styles)
  }, [_hoisted_1, _createElementVNode("span", null, _toDisplayString($props.text), 1), _createElementVNode("div", _hoisted_2, null, 512)], 4)), [[_directive_touch, $options.handleTouchEnd, "panend"], [_directive_touch, $options.handleTouchMove, "panmove"]]) : _createCommentVNode("", true);
}